import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_META_ORDER} from "../../queries/sales";
import {Link} from "react-router";

const MetaOrderInfoPanel = (props) => {

  function getShippingOrderIdsType(data) {
    const ids = data.get("shippingOrderIds").map((id) => <Link key={id} to={`/shipping/orders/${id}`}>{id}</Link>);
    return [ids, "string"];
  }

  // function getMessagesType(data) {
  //   const messages = data.get("messages").map((message, i) => <div key={i}>{message}</div>);
  //   return [messages, "string"];
  // }
  function getLastMessage(data) {
    return [data.getIn(["messages", -1], ""), "string"];
  }

  function getTrackingInfoType(data) {
    const infos = data.get("trackingInfo", []).map((info) => <div key={info.get("trackingNumber")}>{info.get("courierId") + " /  " + info.get("trackingNumber")}</div>)
    return [infos, "string"];
  }

  let elements = null;
  if (!props.orderId || props.orderId === "") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "metaOrderId", label: "Meta Order Id", type: "externalOrderId"},
      {prop: "shopId", label: "Shop Id", type: "id"},
      {prop: "state", label: "State", type: "string"},
      {prop: "name", label: "Client Name", type: "string"},
      {prop: "shippingOrderIds", label: "Shipping Order Ids", type: "array", fn: getShippingOrderIdsType},
      {prop: "trackingInfo", label: "Tracking Info", fn: getTrackingInfoType},
      // {prop: "messages", label: "Messages", type: "array", fn: getMessagesType},
      {prop: "lastMessage", label: "Last Message", type: "string", fn: getLastMessage},
      {prop: "source", label: "Source", type: "string"},
      {prop: "createdAt", label: "Created At", type: "utc"},
      {prop: "lastUpdatedAt", label: "Last Updated At", type: "utc"},
      {prop: "isTestOrder", label: "Is Test Order", type: "boolean"},
    ])

    let variables = {metaOrderId: props.orderId}
    elements = (
      <Query query={GET_META_ORDER} variables={variables} skip={props.orderId === ""} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.salesMetaOrder)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Order Info" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default MetaOrderInfoPanel;